module.exports = __webpack_public_path__ + "static/img/kf.3e66b86d.png";